import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_8a5749c4 from 'nuxt_plugin_plugin_8a5749c4' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_7fb5e210 from 'nuxt_plugin_sentryserver_7fb5e210' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_5a6b9d70 from 'nuxt_plugin_sentryclient_5a6b9d70' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_1bd47adc from 'nuxt_plugin_cookieuniversalnuxt_1bd47adc' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_toast_0a700fe3 from 'nuxt_plugin_toast_0a700fe3' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_pluginutils_6846f987 from 'nuxt_plugin_pluginutils_6846f987' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_286f4112 from 'nuxt_plugin_pluginrouting_286f4112' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_758d939d from 'nuxt_plugin_pluginmain_758d939d' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_5dffc70a from 'nuxt_plugin_gtm_5dffc70a' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_libplugin3e1a6718_4d5f21ae from 'nuxt_plugin_libplugin3e1a6718_4d5f21ae' // Source: ./lib.plugin.3e1a6718.js (mode: 'all')
import nuxt_plugin_axios_3e3fc334 from 'nuxt_plugin_axios_3e3fc334' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_nuxtapollomodule_39875384 from 'nuxt_plugin_nuxtapollomodule_39875384' // Source: ./nuxt-apollo-module.js (mode: 'all')
import nuxt_plugin_datefns_032b3a18 from 'nuxt_plugin_datefns_032b3a18' // Source: ./date-fns.js (mode: 'all')
import nuxt_plugin_nuxtpluginccc5b36c_6d19d338 from 'nuxt_plugin_nuxtpluginccc5b36c_6d19d338' // Source: ./nuxt.plugin.ccc5b36c.js (mode: 'all')
import nuxt_plugin_axios_630a4306 from 'nuxt_plugin_axios_630a4306' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_bugsnag_4aea807c from 'nuxt_plugin_bugsnag_4aea807c' // Source: ../plugins/bugsnag (mode: 'all')
import nuxt_plugin_bodyscrolllock_0ed59419 from 'nuxt_plugin_bodyscrolllock_0ed59419' // Source: ../plugins/body-scroll-lock (mode: 'client')
import nuxt_plugin_directives_f60b4746 from 'nuxt_plugin_directives_f60b4746' // Source: ../plugins/directives (mode: 'all')
import nuxt_plugin_hls_280f8894 from 'nuxt_plugin_hls_280f8894' // Source: ../plugins/hls (mode: 'client')
import nuxt_plugin_gtagconsent_396eda39 from 'nuxt_plugin_gtagconsent_396eda39' // Source: ../plugins/gtag-consent (mode: 'client')
import nuxt_plugin_lazysizes_4201e7b6 from 'nuxt_plugin_lazysizes_4201e7b6' // Source: ../plugins/lazysizes (mode: 'client')
import nuxt_plugin_simpleportal_0bb1afee from 'nuxt_plugin_simpleportal_0bb1afee' // Source: ../plugins/simple-portal (mode: 'all')
import nuxt_plugin_validation_b46593c6 from 'nuxt_plugin_validation_b46593c6' // Source: ../plugins/mixins/validation (mode: 'all')
import nuxt_plugin_vcalendar_16d9fd0e from 'nuxt_plugin_vcalendar_16d9fd0e' // Source: ../plugins/v-calendar (mode: 'client')
import nuxt_plugin_vclickoutside_ab7d12e0 from 'nuxt_plugin_vclickoutside_ab7d12e0' // Source: ../plugins/v-click-outside (mode: 'client')
import nuxt_plugin_capacitor_6dc2f849 from 'nuxt_plugin_capacitor_6dc2f849' // Source: ../plugins/capacitor (mode: 'all')
import nuxt_plugin_intent_5d305338 from 'nuxt_plugin_intent_5d305338' // Source: ../plugins/intent.client (mode: 'client')
import nuxt_plugin_auth_26c4af7c from 'nuxt_plugin_auth_26c4af7c' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Reformatorische Omroep","titleTemplate":(t) => {
      return t + (t === 'Reformatorische Omroep' ? '' : ' – Reformatorische Omroep, een vertrouwd geluid');
    },"htmlAttrs":{"lang":"nl"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","hid":"description","content":""},{"name":"apple-mobile-web-app-title","hid":"apple-mobile-web-app-title","content":"Reformatorische Omroep"},{"name":"og:title","hid":"og:title","content":"Reformatorische Omroep"},{"name":"og:description","hid":"og:description","content":""},{"name":"og:site_name","hid":"og:site_name","content":"Reformatorische Omroep"},{"name":"msapplication-TileColor","hid":"msapplication-TileColor","content":"#FF9900"},{"name":"theme-color","hid":"theme-color","content":"#FF9900"}],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TKX2HGRS')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizers":[],"link":[{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.bunny.net\u002Fcss2?family=Lora:wght@500&family=Ubuntu:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap"},{"rel":"apple-touch-icon","sizes":"152x152","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"manifest","href":"\u002Fsite.webmanifest"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#FF9900"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TKX2HGRS&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_8a5749c4 === 'function') {
    await nuxt_plugin_plugin_8a5749c4(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_7fb5e210 === 'function') {
    await nuxt_plugin_sentryserver_7fb5e210(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_5a6b9d70 === 'function') {
    await nuxt_plugin_sentryclient_5a6b9d70(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_1bd47adc === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_1bd47adc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_0a700fe3 === 'function') {
    await nuxt_plugin_toast_0a700fe3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_6846f987 === 'function') {
    await nuxt_plugin_pluginutils_6846f987(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_286f4112 === 'function') {
    await nuxt_plugin_pluginrouting_286f4112(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_758d939d === 'function') {
    await nuxt_plugin_pluginmain_758d939d(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_5dffc70a === 'function') {
    await nuxt_plugin_gtm_5dffc70a(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin3e1a6718_4d5f21ae === 'function') {
    await nuxt_plugin_libplugin3e1a6718_4d5f21ae(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3e3fc334 === 'function') {
    await nuxt_plugin_axios_3e3fc334(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtapollomodule_39875384 === 'function') {
    await nuxt_plugin_nuxtapollomodule_39875384(app.context, inject)
  }

  if (typeof nuxt_plugin_datefns_032b3a18 === 'function') {
    await nuxt_plugin_datefns_032b3a18(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtpluginccc5b36c_6d19d338 === 'function') {
    await nuxt_plugin_nuxtpluginccc5b36c_6d19d338(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_630a4306 === 'function') {
    await nuxt_plugin_axios_630a4306(app.context, inject)
  }

  if (typeof nuxt_plugin_bugsnag_4aea807c === 'function') {
    await nuxt_plugin_bugsnag_4aea807c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bodyscrolllock_0ed59419 === 'function') {
    await nuxt_plugin_bodyscrolllock_0ed59419(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_f60b4746 === 'function') {
    await nuxt_plugin_directives_f60b4746(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hls_280f8894 === 'function') {
    await nuxt_plugin_hls_280f8894(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtagconsent_396eda39 === 'function') {
    await nuxt_plugin_gtagconsent_396eda39(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazysizes_4201e7b6 === 'function') {
    await nuxt_plugin_lazysizes_4201e7b6(app.context, inject)
  }

  if (typeof nuxt_plugin_simpleportal_0bb1afee === 'function') {
    await nuxt_plugin_simpleportal_0bb1afee(app.context, inject)
  }

  if (typeof nuxt_plugin_validation_b46593c6 === 'function') {
    await nuxt_plugin_validation_b46593c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vcalendar_16d9fd0e === 'function') {
    await nuxt_plugin_vcalendar_16d9fd0e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vclickoutside_ab7d12e0 === 'function') {
    await nuxt_plugin_vclickoutside_ab7d12e0(app.context, inject)
  }

  if (typeof nuxt_plugin_capacitor_6dc2f849 === 'function') {
    await nuxt_plugin_capacitor_6dc2f849(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_intent_5d305338 === 'function') {
    await nuxt_plugin_intent_5d305338(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_26c4af7c === 'function') {
    await nuxt_plugin_auth_26c4af7c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
